import { useState, type FormEvent } from 'react';
import { toast } from 'sonner';
import { ApiError, api, setTokens } from '../../lib/api';
import { useAuth } from '../../lib/auth';
import { Button } from '../../ui/core';
import { Field, TextInput } from '../../ui/form';
import { AramisMark } from '../../layout/Brand';

/** Required on first sign-in with a temporary password; also used from Settings. */
export function ChangePassword({ forced = false }: { forced?: boolean }) {
  const { reload } = useAuth();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', repeat: '' });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (form.newPassword !== form.repeat) return setErrors({ repeat: 'تکرار رمز با رمز جدید یکسان نیست.' });
    setBusy(true); setErrors({});
    try {
      setTokens(await api('/admin/auth/password', { body: { currentPassword: form.currentPassword, newPassword: form.newPassword } }));
      toast.success('رمز عبور تغییر کرد. نشست‌های دیگر شما بسته شد.');
      setForm({ currentPassword: '', newPassword: '', repeat: '' });
      await reload();
    } catch (err) {
      if (err instanceof ApiError) setErrors(err.fields ?? { _: err.message });
    } finally { setBusy(false); }
  };
  const body = (
    <form onSubmit={submit} className="flex w-full max-w-[380px] flex-col gap-4" noValidate>
      <Field label="رمز فعلی" error={errors.currentPassword}><TextInput type="password" ltr autoComplete="current-password" value={form.currentPassword} onChange={(e) => setForm({ ...form, currentPassword: e.target.value })} /></Field>
      <Field label="رمز جدید" hint="حداقل ۸ نویسه" error={errors.newPassword}><TextInput type="password" ltr autoComplete="new-password" value={form.newPassword} onChange={(e) => setForm({ ...form, newPassword: e.target.value })} /></Field>
      <Field label="تکرار رمز جدید" error={errors.repeat}><TextInput type="password" ltr autoComplete="new-password" value={form.repeat} onChange={(e) => setForm({ ...form, repeat: e.target.value })} /></Field>
      {errors._ && <p role="alert" className="text-[13px] text-danger">{errors._}</p>}
      <Button type="submit" variant="primary" loading={busy} className="self-start">تغییر رمز</Button>
    </form>
  );
  if (!forced) return body;
  return (
    <main className="grid min-h-dvh place-items-center px-4">
      <div className="w-full max-w-[380px]">
        <AramisMark className="mb-6 size-10" />
        <h1 className="text-xl font-medium">رمز موقت را عوض کنید</h1>
        <p className="mb-6 mt-1 text-muted">برای امنیت حساب، پیش از شروع کار یک رمز شخصی انتخاب کنید.</p>
        {body}
      </div>
    </main>
  );
}
